module.exports = __webpack_public_path__ + "static/media/logo-black.70c3f771.png";